module.exports = __webpack_public_path__ + "img/chevron-forward-white.43afcf5c.svg";